import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { prayerTimesActions } from "../../Redux";
import { getPrayerTimesState } from "../../Redux/GetState";
import { getPrayerTime, makeDate } from "../Helpers";
import { IPrayerNotification } from "./IPrayerNotification";

export const PrayerNotification: React.FC<IPrayerNotification> = (
  props: IPrayerNotification
): JSX.Element => {
  const { prayerTimes } = useSelector(getPrayerTimesState);
  const [date, setDate] = useState(new Date());
  const { reloadData } = useSelector(getPrayerTimesState);
  const { apiError } = useSelector(getPrayerTimesState);

  const dispatch = useDispatch();

  function requireNotification() {
    const today = getPrayerTime(prayerTimes, props.dateTime.getDate());

    if (!today) {
      return;
    }

    const fajarNotification = makeDate(today.JumatFajar);
    const zoharNotification = makeDate(today.JumatZohar);
    const asarNotification = makeDate(today.JumatAsar);
    const startMaghribNotification = makeDate(today.StartMaghrib);
    const maghribNotification = makeDate(today.JumatMaghrib);
    const ishaNotification = makeDate(today.JumatIsha);
    const nowDateTime = makeDate(date);
    const jumaah1Notification = makeDate(
      today.Jumaah1 ? today.Jumaah1 : today.JumatZohar
    );
    const jumaah2Notification = makeDate(
      today.Jumaah2 ? today.Jumaah2 : today.JumatZohar
    );
    const jumaah3Notification = makeDate(
      today.Jumaah3 ? today.Jumaah3 : today.JumatZohar
    );

    if (
      nowDateTime.getTime() === fajarNotification.getTime() ||
      nowDateTime.getTime() === zoharNotification.getTime() ||
      nowDateTime.getTime() === asarNotification.getTime() ||
      (today.IsRamadanDay &&
        nowDateTime.getTime() === startMaghribNotification.getTime()) ||
      nowDateTime.getTime() === maghribNotification.getTime() ||
      nowDateTime.getTime() === ishaNotification.getTime() ||
      nowDateTime.getTime() === jumaah1Notification.getTime() ||
      nowDateTime.getTime() === jumaah2Notification.getTime() ||
      nowDateTime.getTime() === jumaah3Notification.getTime()
    ) {
      var audio = new Audio("https://dashboard.farooqiah.co.uk/bell.ogg");
      audio.play();
    }
  }

  function requireUpdate() {
    if (reloadData < date) {
      let now = new Date();
      let dt = now.setHours(now.getSeconds() + 15);

      const futureDate = new Date(dt);
      dispatch(prayerTimesActions.setReloadData(futureDate));
    }
  }

  useEffect(() => {
    setDate(props.dateTime);
    requireNotification();
    requireUpdate();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.dateTime]);

  return <></>;
};
